export default __webpack_public_path__ + "static/media/airbuds.8b8dba53.jpg";